import components from "../components";

export default (editor, opts = {}) => {
    const COMPS = editor.DomComponents;
    const TYPE = COMPS.getType('container');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    COMPS.addType('C-ACCEPTANCE-TERMS', {
        model:  MODEL.extend({
            defaults: {
                ...MODEL.prototype.defaults,
                name:"C-ACCEPTANCE-TERMS",
                "custom-name":"C-ACCEPTANCE-TERMS",
                tagName:'div',
                droppable: false, 
                classes:['form-check'],
                attributes:{
                    'data-slg-type':'C-ACCEPTANCE-TERMS'
                },
                components:[
                    {
                        type:'input',
                        droppable: false, 
                        attributes:{
                            type:'checkbox',
                            required:true
                        },
                        classes:['form-check-input']
                    },
                    {
                        type:"label",
                        droppable: false, 
                        classes:['form-check-label'],
                        components:[
                            {
                                type:"link",
                                droppable: false,
                                attributes:{
                                    href: "#"
                                },
                                content:"Accept terms and conditions"
                            }
                        ]
                    }
                ]
            },
            onRender(){
                
            },
        },{
            isComponent(el) {
                if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-ACCEPTANCE-TERMS")
                    return { type:'C-ACCEPTANCE-TERMS' }
            },
        }),
        view:VIEW.extend({
            init(){
                let component = this.model;
            },
            
        })
    });


}
